import React from 'react';
import { Login } from '../../../types/models/login';
import { LoginItem } from './login-item';

interface LoginsProps {
  logins: Array<Login>;
}

export function Logins(props: LoginsProps) {
  return (
    <>
      {props.logins.map((l) => (
        <LoginItem key={l.username} login={l} />
      ))}
    </>
  );
}
